// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","container":"styles_container__3DoBB","answer":"styles_answer__21vMh","question":"styles_question__3Y7-F"};